import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import ViewTypeLabel from "views/components/ViewTypeLabel";
import View from "views/logic/views/View";
import { Col, Row, Button } from "components/bootstrap";
import fixup from "views/pages/StyleFixups.css";
import useHistory from "routing/useHistory";
const PluginLink = ({ url, children = void 0 }) => /* @__PURE__ */ React.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer" }, children);
const MissingRequirements = ({ view, missingRequirements }) => {
  const { t } = useTranslation("search");
  const history = useHistory();
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 6, mdOffset: 3, className: fixup.bootstrapHeading }, /* @__PURE__ */ React.createElement("h1", null, ViewTypeLabel({ type: view.type, capitalize: true }), ": ", /* @__PURE__ */ React.createElement("em", null, view.title)), /* @__PURE__ */ React.createElement("p", null, view.type === View.Type.Dashboard ? t("missing_requirements.description_dashboard") : t("missing_requirements.description_search")), /* @__PURE__ */ React.createElement("ul", null, Object.entries(missingRequirements).map(([require, plugin]) => /* @__PURE__ */ React.createElement("li", { key: require }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "missing_requirements.included_in",
      values: { requirement: require, plugin: plugin.name },
      components: {
        requirementName: /* @__PURE__ */ React.createElement("strong", null),
        pluginLink: /* @__PURE__ */ React.createElement(PluginLink, { url: plugin.url })
      }
    }
  ))))), /* @__PURE__ */ React.createElement(Col, { md: 1, mdOffset: 8 }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: () => history.goBack() }, t("missing_requirements.back"))));
};
export default MissingRequirements;
